import styled from "styled-components";

export const LogsPageWrapper = styled.div`
  padding: 24px 0;
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  align-items: flex-end;
`;

export const FilterItem = styled.div`
  min-width: 200px;
  flex: 1;
  max-width: 300px;
`;

export const LogsTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
`;

export const LogsTableHeader = styled.div`
  display: grid;
  grid-template-columns: 80px 100px 1fr 180px 100px;
  gap: 16px;
  padding: 12px 20px;
  background: #f5f5f5;
  font-size: 12px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const LogsTableRow = styled.div`
  display: grid;
  grid-template-columns: 80px 100px 1fr 180px 100px;
  gap: 16px;
  padding: 12px 20px;
  background: #fff;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #f9f9f9;
  }
`;

export const MethodBadge = styled.span<{ method?: string }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  font-family: "Roboto Mono", monospace;
  color: white;
  text-transform: uppercase;
  background: ${({ method }) => {
    switch (method?.toLowerCase()) {
      case "get": return "#1976d2";
      case "post": return "#2e7d32";
      case "put": return "#ed6c02";
      case "patch": return "#9c27b0";
      case "delete": return "#d32f2f";
      default: return "#757575";
    }
  }};
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
  color: #888;
  font-size: 15px;
`;

export const PaginationRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
